import React, { useEffect, useState } from 'react';
import { ButtonContain, ButtonOutline, } from 'component/material/ButtonContained/Button';
import MaterialTable from 'material-table';
import { osName, browserName, browserVersion } from 'react-device-detect';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import { useDispatch } from 'react-redux';
import { setLoadingRedux } from 'reducers/sharedata/action';
import StyleA from 'component/utility/StyledA';
import { versionOld, checkOS, checkBrowser, WebSocketTest, } from './WebSocketFunc';
// component --------------------------------------------------------------------------
var PassText = function (value) {
    if (value)
        return React.createElement("span", { style: { color: 'green' } }, "\u901A\u904E");
    return React.createElement("span", { style: { color: 'red' } }, "\u672A\u901A\u904E");
};
var SystemCheck = function (props) {
    var dispatch = useDispatch();
    var onDlg = props.onDlg, handleNext = props.handleNext, handleBack = props.handleBack;
    var _a = useState(false), machine = _a[0], setMachine = _a[1];
    var _b = useState(''), version = _b[0], setVersion = _b[1];
    var checkWebSocketVersion = function () {
        dispatch(setLoadingRedux(1));
        var params = {};
        WebSocketTest('version', function (ws) { return function () {
            ws.send(JSON.stringify(params));
        }; }, function (ws) { return function (response) {
            var obj = JSON.parse(response.data);
            var versionTemp = obj.data.version;
            // 啟用失敗(未測到此情況)，或版本較舊，必須更新
            if (!obj.success || versionOld(versionTemp, osName)) {
                setMachine(false);
            }
            // 啟用成功
            else {
                setMachine(true);
            }
            // 關閉元件？
            ws.close();
            setVersion(versionTemp);
            dispatch(setLoadingRedux(-1));
        }; }, function (ws) { return function () {
            // IE 於 readyState === 2 必進 error，但並不是 error
            if (browserName === 'IE' && ws.readyState === 2) {
                return;
            }
            setVersion('');
            setMachine(false);
            dispatch(setLoadingRedux(-1));
        }; });
    };
    useEffect(function () {
        checkWebSocketVersion();
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: 10 } },
            "\u203B\u5EFA\u8B70\u4F7F\u7528Google Chrome\u700F\u89BD\u5668\u4EE5\u53D6\u5F97\u6700\u4F73\u6548\u679C",
            React.createElement("br", null),
            "\u203B\u82E5\u60A8\u4F7F\u7528IE\uFF0C\u8ACB\u8ABF\u6574\u700F\u89BD\u5668\u76F8\u5BB9\u6027",
            React.createElement("br", null),
            "\u5DE5\u5177 ",
            '>',
            " IE \u7DB2\u969B\u7DB2\u8DEF\u8A2D\u5B9A ",
            '>',
            " \u5B89\u5168\u6027 ",
            '>',
            " \u8FD1\u7AEF\u5167\u90E8\u7DB2\u8DEF ",
            '>',
            " [\u7DB2\u7AD9]",
            '>',
            " \u8ACB\u4E0D\u8981\u52FE\u9078[\u5305\u542B\u6240\u6709\u672A\u5217\u5728\u5176\u4ED6\u5340\u57DF\u7684\u8FD1\u7AEF\u5167\u90E8\u7DB2\u969B\u7DB2\u8DEF(Z)]",
            React.createElement("br", null),
            "Tools ",
            '>',
            " Internet Options ",
            '>',
            " Security ",
            '>',
            " Local Intranet ",
            '>',
            "Sites ",
            '>',
            " Include all local (intranet) sites not listed network",
            React.createElement("div", null,
                React.createElement(StyleA, { href: "/usermanual/Firefox\u8A2D\u5B9A.pdf", download: true, style: { color: 'red' } }, "\u82E5\u4F7F\u7528 Firefox \u700F\u89BD\u5668\uFF0C\u8ACB\u4E0B\u8F09\u9644\u4EF6\u9032\u884C\u8A2D\u5B9A"))),
        React.createElement(MaterialTable, { options: {
                toolbar: false,
                paging: false,
                sorting: false,
                headerStyle: {
                    backgroundColor: 'rgb(137, 134, 134)',
                    color: 'white',
                    textAlign: 'center',
                },
            }, columns: [
                {
                    title: '檢查項目',
                    field: 'item',
                    cellStyle: { textAlign: 'center' },
                },
                {
                    title: '檢查狀態',
                    field: 'status',
                    cellStyle: { textAlign: 'center' },
                },
                {
                    title: '是否通過',
                    field: 'pass',
                    cellStyle: { textAlign: 'center' },
                },
            ], data: [
                { item: '作業系統', status: osName, pass: PassText(checkOS(osName)) },
                {
                    item: '瀏覽器',
                    status: browserName,
                    pass: PassText(checkBrowser(browserName, browserVersion)),
                },
                {
                    item: '自然人憑證元件',
                    status: (React.createElement(React.Fragment, null,
                        !version
                            ? '未安裝客戶端程式或未啟動服務'
                            : "\u5143\u4EF6\u7248\u672C\uFF1A" + version,
                        React.createElement(ButtonOutline, { size: "small", style: { margin: '0 5px' }, onClick: function () { return checkWebSocketVersion(); } }, "\u91CD\u65B0\u6AA2\u6E2C"))),
                    pass: (React.createElement(React.Fragment, null, machine ? (PassText(true)) : (React.createElement("a", { href: "/TvCryptoSetup.exe", download: true }, "\u8ACB\u4E0B\u8F09\u3001\u5B89\u88DD\u81EA\u7136\u4EBA\u6191\u8B49\u5143\u4EF6")))),
                },
            ] }),
        React.createElement(ButtonBar, { style: onDlg ? { paddingBottom: 0 } : {} },
            React.createElement(ButtonContain, { variant: "outlined", onClick: handleBack }, "\u8FD4\u56DE"),
            React.createElement(ButtonContain, { disabled: !(checkOS(osName) &&
                    checkBrowser(browserName, browserVersion) &&
                    machine), onClick: handleNext }, "\u4E0B\u4E00\u6B65"))));
};
export default SystemCheck;
